import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { FormControlContainer } from '../../../components/formControlContainer';
import { DualLimitIcon } from '../../../icons/dualLimitIcon';
import { setCreateGameIsDualLimitEnabled } from '../../../redux/actions/createGameActions';
import { selectIsDualLimitAutoEnabled } from '../../../redux/reducers/createGameReducer';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { LIGHT_BLUE_COLOR } from '../../../styles/colors';
import { ALL_POKER_VARIANT_PROPERTIES } from '../../../types/pokerVariantTypes';
import { CreateGameMenuItemContents } from './createGameMenuItemContents';
const MAIN_CSS = css `
  display: flex;
  flex-flow: row wrap;
  gap: 10px;
  align-items: center;
`;
const UL_CSS = css `
  margin: 0;
`;
const LIMIT_LABEL_CSS = css `
  color: ${LIGHT_BLUE_COLOR};
`;
const ALL_LIMIT_TYPE_PROPERTIES = [
    {
        label: 'Dual Limit',
        description: (_jsx(Typography, { variant: 'subtitle2', component: 'div', children: _jsxs("ul", { css: UL_CSS, children: [_jsxs("li", { children: ["Pre-Flop & Flop: ", _jsx("span", { css: LIMIT_LABEL_CSS, children: "Pot Limit" })] }), _jsxs("li", { children: ["Turn & River: ", _jsx("span", { css: LIMIT_LABEL_CSS, children: "No Limit" })] })] }) })),
        icon: DualLimitIcon
    },
    { label: 'No Limit' }
];
export const LimitTypeControl = () => {
    const dispatch = useAppDispatch();
    const isDualLimitEnabled = useAppSelector((state) => state.createGame.isDualLimitEnabled);
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const variantId = useAppSelector((state) => state.createGame.variantId);
    const isDualLimitAutoEnabled = useAppSelector(selectIsDualLimitAutoEnabled);
    const onChangeLimitsType = useCallback((event) => {
        const limitTypeIndex = Number(event.target.value);
        dispatch(setCreateGameIsDualLimitEnabled(limitTypeIndex === 0));
    }, [dispatch]);
    if (roomType !== 'regular') {
        // TODO: Determine if mixed games allows dual limit on some of its variants?
        return null;
    }
    const variantProperties = Object.values(ALL_POKER_VARIANT_PROPERTIES).find(({ variantId: currVariantId }) => currVariantId === variantId);
    if (!variantProperties) {
        // variant not found
        return null;
    }
    if (!variantProperties.availableLimitTypes.includes('dual-limit')) {
        return null;
    }
    const limitTypeIndex = isDualLimitEnabled ? 0 : 1;
    return (_jsxs(FormControlContainer, { children: [_jsxs("div", { css: MAIN_CSS, children: [_jsxs(FormControl, { variant: 'outlined', children: [_jsx(InputLabel, { children: "Limits" }), _jsx(Select, { "data-testid": 'create-game-limits-select', value: `${limitTypeIndex}`, label: 'Limits', onChange: onChangeLimitsType, disabled: isDualLimitAutoEnabled, children: ALL_LIMIT_TYPE_PROPERTIES.map(({ label, icon }, i) => (_jsx(MenuItem, { value: i, children: _jsx(CreateGameMenuItemContents, { icon: icon, label: label }) }, i))) })] }), ALL_LIMIT_TYPE_PROPERTIES[limitTypeIndex].description] }), isDualLimitAutoEnabled && (_jsx(Typography, { variant: 'subtitle2', component: 'div', color: 'secondary', children: "Increase Buy-in to select No Limit." }))] }));
};
